import React from "react"
import './ourLadership.css';
import { useSelector} from 'react-redux'
import { useState,useEffect } from "react";
import ourLadership from '../../../../src/assets/Leadership.png'

  function OurLadership() {

    let boolean = useSelector((state) => state.boolean.bool)
    let [texte,setTexte]=useState()
    let [titre,setTitre]=useState()

    useEffect(() => {
      // Update the document title using the browser API
      if(boolean===false){
        setTexte(texteFR)
        setTitre(titreFR)
     }
     else{
      setTexte(texteANG)
      setTitre(titreENG)
     }
     console.log(texte)
    });

    //le textes en deux langues
    let texteFR="Notre équipe de direction apporte une expertise en audiovisuel issue de divers marchés internationaux. Cela s’appuie sur des relations et partenariats établis dans les secteurs de l’audiovisuel et des technologies de l’information. Notre équipe dirigeante est composée de professionnels expérimentés ayant géré des projets dans plusieurs pays, de l’Europe aux États-Unis et à l’Asie, et propose des solutions pratiques pour l’intégration audiovisuelle. Ils collaborent étroitement avec les clients, de la conception initiale à la livraison finale, afin d’assurer le bon déroulement des projets et le respect des exigences. Contactez-nous pour discuter de la manière dont nous pouvons soutenir vos objectifs audiovisuels.";
    let texteANG="Our leadership team brings AV expertise from diverse international markets. This is supported by established relationships and partnerships in the AV and IT sectors. Our executive team includes experienced professionals who have managed projects in multiple countries, from Europe to the US and Asia and provide practical solutions for AV integration. They work closely with clients from initial concepts to final delivery to ensure projects run smoothly and meet requirements. Contact us to discuss how we can support your AV goals.";

    let titreFR= "Expertise mondiale au service de votre réussite"
    let titreENG= "Global Expertise Driving Your Success"

    return (
      <section className="ourLadershipSection">

        <div className="ourLadershipGlobalDiv">
          
          <div className="ourLadershipPictureDiv">
          <img  src={ourLadership} className="ourLadershipPicture" alt="" />
          </div>
          
          <div className="ourLadershipTextDiv">
          <h3 className="ourLadershipTitle">{titre}</h3>
            <p className="ourLadershipText">{texte}</p>
          </div>

        </div>
          
      </section>
    )
  }

  export default OurLadership;
